module.exports = __webpack_public_path__ + "img/Werkstatt.3f2f2d61.svg";